import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Box, Flex, useColorModeValue } from "@chakra-ui/react";

import {
  PROVIDER_FORM_COMPONENTS_PER_TYPE,
  PROVIDER_FORM_LEGENDS_PER_TYPE
} from "components/Condominiums/Providers/ProviderForm/constants";
import { ProviderFormType } from "components/Condominiums/Providers/ProviderForm/types";

export const SaveProvider = () => {
  const { providerId } = useParams();
  const [type, setType] = useState<ProviderFormType>("create");

  const ProviderFormComponent = PROVIDER_FORM_COMPONENTS_PER_TYPE[type];
  const ProviderLegendComponent = PROVIDER_FORM_LEGENDS_PER_TYPE[
    type
  ];

  function setupForm() {
    if (providerId) {
      setType("edit");
    }
  }

  useEffect(() => {
    setupForm();
  }, [providerId]);

  return (
    <Flex
      bg={useColorModeValue("gray.50", "gray.800")}
      justifyContent={"left"}
      padding={5}
    >
      <Box width="100%">
        <Box textAlign={"left"} py={10} px={2}>
          <ProviderLegendComponent />
        </Box>
        <Box
          margin={2}
          display="flex"
          flexDirection={{
            base: "column-reverse",
            lg: "row"
          }}
          gap={10}
          justifyContent={{
            base: "center",
            lg: "space-between"
          }}
        >
          <ProviderFormComponent />
        </Box>
      </Box>
    </Flex>
  );
};
